$(document).ready(function() { 
var maincontent = $('.customfooter-newsletter-wrapper-container');
let result = maincontent.slice(-1).remove();
});


$(function() {
    var header = $('body');
      $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 8780) {
           header.addClass('scrollActive');
      } else {
           header.removeClass('scrollActive');
        
        }
    });
})

  $(document).on("click", ".anchorbutton", function(e){
  e.preventDefault();
  $('html, body').animate({
  scrollTop: $(".footer-newsletter-wrapper-container").offset().top
  }, 1000)
  
  });
